import { useLayoutEffect, useTransition } from 'react';

import { useForceUpdate } from '@spazious/react-hooks';

import { useDataTableContext } from './useDataTableContext.js';

/**
 * Hook for registering a cell in the data table
 */
export const useDataTableCell = (columnIndex: number, rowIndex: number) => {
  const forceUpdate = useForceUpdate();
  const [, startTransaction] = useTransition();
  const { manager, unregister, register } = useDataTableContext();

  useLayoutEffect(
    () =>
      manager.subscribe(() => {
        startTransaction(() => {
          forceUpdate();
        });
      }),
    [forceUpdate, manager]
  );

  useLayoutEffect(
    () => () => unregister(columnIndex, rowIndex),
    [columnIndex, rowIndex, unregister]
  );

  return {
    innerRef: register(columnIndex, rowIndex),
    attributes: {
      width: manager.getColumnWidth(columnIndex),
      height: manager.getRowHeight(rowIndex),
    } as React.CSSProperties,
  };
};
